import { default as Mui4Link, LinkProps as Mui4LinkPropsType } from '@material-ui/core/Link'
import { default as Mui5Link } from '@mui/material/Link'
import React, { ForwardedRef, forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

export enum LinkVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export interface LinkProps extends Mui4LinkPropsType {
  component?: React.ElementType
}

// * MUI Link API Spec  https://mui.com/material-ui/api/Link/
export const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref: ForwardedRef<HTMLAnchorElement>) => {
  const version = useComponentVersion('link')

  switch (version) {
    case LinkVersion.V2: {
      const { variant, ...restProps } = props
      return <Mui5Link component={props.component} ref={ref} {...restProps} />
    }

    default:
      return <Mui4Link {...props} />
  }
})
